import React from 'react';
import { useLang } from '../context/LanguageContext';

const FlagFR = () => (
  <svg viewBox="0 0 3 2" className="lang-flag-svg" aria-hidden="true">
    <rect width="1" height="2" x="0" fill="#0055A4" />
    <rect width="1" height="2" x="1" fill="#FFFFFF" />
    <rect width="1" height="2" x="2" fill="#EF4135" />
  </svg>
);

const FlagDE = () => (
  <svg viewBox="0 0 5 3" className="lang-flag-svg" aria-hidden="true">
    <rect width="5" height="1" y="0" fill="#000000" />
    <rect width="5" height="1" y="1" fill="#DD0000" />
    <rect width="5" height="1" y="2" fill="#FFCE00" />
  </svg>
);

export default function LanguagePopup() {
  const { hasChosen, setLang } = useLang();

  if (hasChosen) return null;

  return (
    <div className="lang-popup-overlay" role="dialog" aria-modal="true" aria-labelledby="lang-popup-title">
      <div className="lang-popup">
        <div className="lang-popup-icon">
          <i className="fa-solid fa-globe" />
        </div>
        <h2 id="lang-popup-title">
          Choisissez votre langue
          <br />
          <span style={{ fontSize: '0.75em', fontWeight: 500, color: 'rgba(255,255,255,0.6)' }}>
            Wählen Sie Ihre Sprache
          </span>
        </h2>
        <p>Vous pourrez la changer à tout moment dans le menu.</p>

        <div className="lang-popup-choices">
          <button type="button" className="lang-popup-choice" onClick={() => setLang('fr')}>
            <span className="lang-flag" aria-hidden="true"><FlagFR /></span>
            <span className="lang-popup-choice-name">Français</span>
            <span className="lang-popup-choice-code">FR</span>
          </button>
          <button type="button" className="lang-popup-choice" onClick={() => setLang('de')}>
            <span className="lang-flag" aria-hidden="true"><FlagDE /></span>
            <span className="lang-popup-choice-name">Deutsch</span>
            <span className="lang-popup-choice-code">DE</span>
          </button>
        </div>
      </div>
    </div>
  );
}
